import React from "react";
import ReactDOM from "react-dom";
import App from "App";

import "assets/css/material-dashboard-react.css?v=1.9.0";
import "react-dropzone-uploader/dist/styles.css";

ReactDOM.render(<App />, document.getElementById("root"));
